import { every, map, size } from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  MenuPopover,
  MenuTrigger,
} from '@fluentui/react-components';
import {
  AddRegular,
} from '@fluentui/react-icons';
import { AdTypeStrings } from '../../constants/ad-type';

export const CreateAdButton = ({
  i18n,
  adTypes,
  onCreateAd,
}) => (
  <div className="create-ad-button">
    {size(adTypes) === 1 && (
      <Button
        icon={<AddRegular />}
        disabled={adTypes[0].disabled}
        onClick={() => onCreateAd(adTypes[0].adType)}
      >
        {i18n.getString(_TL_('Create ad'))}
      </Button>
    )}
    {size(adTypes) > 1 && (
      <Menu>
        <MenuTrigger disableButtonEnhancement>
          <MenuButton
            icon={<AddRegular />}
            disabled={every(adTypes, adType => adType.disabled)}
          >
            {i18n.getString(_TL_('Create ad'))}
          </MenuButton>
        </MenuTrigger>
        <MenuPopover>
          <MenuList>
            {map(adTypes, ({ adType, disabled }) => (
              <MenuItem
                key={adType}
                disabled={disabled}
                onClick={() => onCreateAd(adType)}
              >
                {i18n.getString(AdTypeStrings[adType])}
              </MenuItem>
            ))}
          </MenuList>
        </MenuPopover>
      </Menu>
    )}
  </div>
);

CreateAdButton.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  adTypes: PropTypes.arrayOf(PropTypes.shape({
    adType: PropTypes.string,
    disabled: PropTypes.bool,
  })),
  onCreateAd: PropTypes.func.isRequired,
};

CreateAdButton.defaultProps = {
  adTypes: [],
};
